import { GroupType, NameAssertion, ResponseItemType } from "@searchui-searchforms/shared/form-metadata";
import type { FormMetadataResponse } from "@searchui-searchforms/shared/form-metadata";

export interface RequiredNameFields {
    /** True when the given name (First Name) is required for search, so its exactness is locked to Exact. */
    givenName: boolean;
    /** True when the surname (Last Name) is required for search, so its exactness is locked to Exact. */
    surname: boolean;
}

/**
 * Reports which name fields are required for search. A required-for-search name field cannot be
 * fuzzy-matched, so its exactness is locked to a static "Exact". This is the single source of that
 * domain rule — consumers use it to seed/keep the exact-only value and to keep the forced value out
 * of persisted user preferences. See TT-3965.
 */
export const getRequiredNameFields = (formMetadata: FormMetadataResponse): RequiredNameFields => {
    let givenName = false;
    let surname = false;

    for (const entry of formMetadata.fieldGroupsAndFeatureContainers) {
        if (entry.type !== ResponseItemType.FieldGroup || entry.groupType !== GroupType.Name) continue;
        for (const field of entry.fields) {
            if (field.assertion === NameAssertion.GivenName && field.features.required) givenName = true;
            if (field.assertion === NameAssertion.Surname && field.features.required) surname = true;
        }
    }

    return { givenName, surname };
};
